import { Inline, Stack, Text } from "@origin-digital/ods-core";
import { formatLabel } from "@/utils";
import React from "react";
import { batterySupported as batterySupportedContent } from "../content.json";
import SunAndBatteryIllustration from "@/assets/sunAndBattery.svg";

export const Outcome = ({
  biggestBatterySize,
  currentExcessExport,
}: {
  biggestBatterySize: number;
  currentExcessExport: number;
}) => {
  return (
    <Inline space={"medium"} alignY={"center"} disableWrap={true}>
      <SunAndBatteryIllustration />
      <Stack space={"none"}>
        <Text tone={"neutralDark"}>
          <b>
            {formatLabel(
              batterySupportedContent.outcome.heading,
              (value) => (
                <>{value}</>
              ),
              biggestBatterySize
            )}
          </b>
        </Text>
        <Text tone={"neutralDark"}>
          {formatLabel(
            batterySupportedContent.outcome.description,
            (value) => (
              <>{value}</>
            ),
            currentExcessExport
          )}
        </Text>
      </Stack>
    </Inline>
  );
};
